import translate from '@translate';
import React, { FC, useEffect, useState } from 'react';
import Select, { OnChangeType, SelectValueType } from 'src/components/Select';
import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearSelectedCountry,
    getPplPlaceByAddressIdFetch,
    getPplPlacesFetch,
} from 'src/resources/pplPlaces/reducer';
import Grid, { GridItem } from '../Grid';

export interface PplPlacesSelectPropsType {
    onChange: OnChangeType;
    onRecipientStateChange?: OnChangeType;
    value: SelectValueType;
    error?: boolean;
    name?: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
    recipientState?: string;
    pointType?: string;
}

const dataCountries = [
    {
        label: 'Czech Republic',
        value: 'cz',
    },
    {
        label: 'Germany',
        value: 'de',
    },
    {
        label: 'Slovakia',
        value: 'sk',
    },
    {
        label: 'Poland',
        value: 'pl',
    },
];

const PplPlacesSelect: FC<PplPlacesSelectPropsType> = (props) => {
    const dispatch = useDispatch();

    const isParcelBox = props.pointType === 'ParcelBox';
    const data = useSelector((state: RootStoreType) => state.pplPlaces.data);
    const selectedCountry = useSelector((state: RootStoreType) => state.pplPlaces.selectedCountry);
    const loading = useSelector((state: RootStoreType) => state.pplPlaces.loading);
    const [country, setCountry] = useState<string | null>(
        isParcelBox ? 'cz' : props.recipientState?.toLowerCase() || null
    );
    const [initialValueFetched, setInitialValueFetched] = useState<boolean>(false);

    useEffect(() => {
        if (isParcelBox && !props.recipientState) {
            props.onRecipientStateChange?.('CZ', false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.value && !initialValueFetched && !props.recipientState && !isParcelBox) {
            dispatch(getPplPlaceByAddressIdFetch(String(props.value)));
            setInitialValueFetched(true);
        } else if (!props.value) {
            dispatch(clearSelectedCountry());
            setInitialValueFetched(false);
        }
    }, [props.value, props.recipientState, isParcelBox, initialValueFetched, dispatch]);

    useEffect(() => {
        if (selectedCountry) {
            setCountry(selectedCountry);
            if (!props.recipientState) {
                props.onRecipientStateChange?.(selectedCountry.toUpperCase(), false);
            }
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (country) {
            dispatch(getPplPlacesFetch({ country, pointType: props.pointType }));
        }
    }, [country, props.pointType, dispatch]);

    useEffect(() => {
        if (props.recipientState && props.recipientState.toLowerCase() !== country) {
            setCountry(props.recipientState.toLowerCase());
        }
    }, [props.recipientState]);

    const options = data || [];

    const isSet = !props.value || options?.filter((option: any): boolean => option.value === props.value).length;
    const allOptions = isSet
        ? options
        : [{ label: `${translate('messages.branchUnavailable')} (${props.value})`, value: props.value }, ...options];

    const handleChangeCountry = (value: any) => {
        if (country !== value) {
            setCountry(String(value));
            props.onRecipientStateChange?.(String(value).toUpperCase(), false);
            if (country) {
                props.onChange(null, true);
            }
        }
    };

    return (
        <Grid>
            <GridItem cols={4}>
                <Select
                    options={dataCountries || []}
                    value={country?.toLowerCase()}
                    error={props.error}
                    onChange={handleChangeCountry}
                    name={`${props.name}country`}
                    label={translate('orderDetail.countryOfDelivery')}
                    required={props.required}
                    disabled={props.disabled || isParcelBox}
                    fullWidth={props.fullWidth}
                    loading={loading}
                />
            </GridItem>
            {!!country && (
                <GridItem cols={8}>
                    <Select
                        options={allOptions}
                        value={props.value}
                        error={props.error}
                        onChange={props.onChange}
                        name={props.name}
                        label={props.label}
                        required={props.required}
                        disabled={props.disabled}
                        fullWidth={props.fullWidth}
                        loading={loading}
                        virtualized
                    />
                </GridItem>
            )}
        </Grid>
    );
};

export default PplPlacesSelect;
